<div class="ac-modal">
	<div *ngIf="showHeader" class="header" [ngClass]="{ 'custom-header': showCustomStepper }">
		<h3 class="text-align-center" data-cy="ac-wizard-title">{{ title }}</h3>
		<div class="row">
			<div class="stepper" [ngClass]="showCustomStepper ? 'col-12' : 'col-24'" *ngIf="stepComponentsArr.length && showStepper">
				<div
					class="step"
					[ngClass]="{
						active: i <= stepIndex,
						'align-items-start': stepComponentsArr.length === 1,
						current: i === stepIndex,
						clickable: stepIndex > i || (stepIndex < i && stepComponentsArr[stepIndex].isNextDisabled === false && stepComponentsArr[i - 1].isNextDisabled === false)
					}"
					*ngFor="let step of stepComponentsArr; let i = index"
					(click)="
						(stepIndex > i || (stepIndex < i && stepComponentsArr[stepIndex].isNextDisabled === false && stepComponentsArr[i - 1].isNextDisabled === false)) &&
							navigateToStep(i)
					"
					[attr.title]="stepIndex < i && stepComponentsArr[stepIndex - 1]?.isNextDisabled ? stepComponentsArr[i - 1].nextDisabledMessage : ''"
				>
					<div class="step-number" *ngIf="stepComponentsArr.length > 1">{{ i + 1 }}</div>
					<div [ngClass]="stepComponentsArr.length > 1 ? 'step-title' : 'text-28-extra-bold'">{{ step.title }}</div>
				</div>
			</div>
			<div *ngIf="showCustomStepper" class="col-12 padding-vertical-10"><ng-content select="[customStepper]"></ng-content></div>
		</div>
	</div>

	<div [ngClass]="{ content: !adaptToContentSize }" [ngStyle]="{ height: contentHeight }" #content><ng-content></ng-content></div>

	<div *ngIf="showFooterActions" class="footer actions clearfix">
		<button dz-button color="secondary" *ngIf="!showStepper && stepIndex === 0" (click)="dontShowAgainStep()" dcrHTMLKey="WIZARD_DONT_SHOW_THIS_AGAIN_BUTTON">
			Don't show this again
		</button>
		<ng-container *ngIf="stepComponentsArr[stepIndex] as step">
			<button
				dz-button
				*ngIf="stepIndex > 0"
				[track-event]="(isImportFlow ? 'import-external-portfolio-' : '') + 'popup:step' + (stepIndex + 1) + ':button:back'"
				(click)="prevStep()"
				color="secondary"
				[disabled]="step.isPrevDisabled"
				[attr.title]="step.backButtonText"
			>
				{{ step.backButtonText }}
			</button>
			<button
				*ngIf="stepIndex < stepComponentsArr.length - 1"
				(click)="nextStep()"
				dz-button
				class="pull-right"
				[disabled]="step.isNextDisabled"
				[attr.title]="step.isNextDisabled ? step.nextDisabledMessage : step.nextButtonText"
				id="mytargetbutton"
				[track-event]="(isImportFlow ? 'import-external-portfolio-' : '') + 'popup:step' + (stepIndex + 1) + ':button:next'"
			>
				{{ step.nextButtonText }}
			</button>
			<button
				*ngIf="stepIndex === stepComponentsArr.length - 1"
				(click)="lastStep()"
				dz-button
				class="pull-right"
				[disabled]="step.isNextDisabled"
				[attr.title]="step.isNextDisabled ? step.nextDisabledMessage : finalStepName"
				[track-event]="
					(isImportFlow ? 'import-external-portfolio-' : '') + 'popup:step' + (stepIndex + 1) + ':button:' + (isImportFlow ? 'import portfolios' : 'run stress test')
				"
			>
				{{ finalStepName }}
			</button>
		</ng-container>
	</div>
</div>
